import React, { useCallback, useMemo } from 'react';
import { getWeekStartEnd } from '../helper/helper';
import { buildPdfFileName, buildPdfFileUrl } from '../helper/newsScrollHelper';
import { useNewsScrollDownload } from '../hooks/useNewsScrollDownload';

function NewsScroll({ entityRef, document, instance, loginRequest }) {
    const fileName = useMemo(
        () => buildPdfFileName(document.year, document.week),
        [document.year, document.week]
    );
    const fileURL = useMemo(
        () => buildPdfFileUrl(fileName, process.env.REACT_APP_API_ROOT_ENDPOINT),
        [fileName]
    );

    const { downloadFile, isDownloading } = useNewsScrollDownload({
        instance,
        loginRequest,
        fileURL,
    });

    const renderEntitySummary = useCallback(
        (entity, j) => {
            const entity_summary = document.entities[entity].entity_summary;
            const summary_lines = entity_summary.split('--').slice(1);

            return (
                <div key={j}>
                    <br />
                    <h2>
                        {entityRef[entity].category}: {entityRef[entity].disp_name}
                    </h2>
                    <p className="entity-header">
                        <b>{entity} News Summary:</b>
                    </p>
                    <p>
                        <b>
                            Year {document.year}, Week {document.week},{' '}
                            {getWeekStartEnd(document.year, document.week)}
                        </b>
                    </p>
                    <br />
                    <div>
                        <ul>
                            {summary_lines.map((line, index) => (
                                <li key={index} dangerouslySetInnerHTML={{ __html: line.trim() }}></li>
                            ))}
                        </ul>
                    </div>
                    <p>
                        <b>
                            <br />
                            AI Analysis
                        </b>
                        : {document.entities[entity].ai_analysis}
                    </p>
                </div>
            );
        },
        [document, entityRef]
    );

    return (
        <div className="App">
            <br />
            <h1 id="alphaliner-title">Alphaliner Weekly - Year {document.year}, Week {document.week}</h1>
            <p>
                <button id="open-pdf-button" onClick={downloadFile} disabled={isDownloading}>
                    {isDownloading ? 'Downloading...' : 'Open Original File'}
                </button>
            </p>
            {Object.keys(document.entities).map(renderEntitySummary)}
        </div>
    );
}

export default React.memo(NewsScroll);